"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityMappingStore = void 0;
var mobx_1 = require("mobx");
var validator_1 = __importDefault(require("validator"));
var IProjectLink_1 = require("@CommonFrontendBackend/Resources/IProjectLink");
var DEFAULT_LIMIT_DOMAINS = { enabled: false, allowedDomains: "" };
var IdentityMappingStore = (function () {
    function IdentityMappingStore(link, debouncedSave) {
        this.link = link;
        this.debouncedSave = debouncedSave;
        if (!!this.link.identityMapping) {
            delete this.link.identityMapping.enabled;
        }
    }
    Object.defineProperty(IdentityMappingStore.prototype, "isLimitDomainsEnabled", {
        get: function () {
            var _a;
            return (_a = this.identityMapping.limitDomains) === null || _a === void 0 ? void 0 : _a.enabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IdentityMappingStore.prototype, "isEmailVerificationEnabled", {
        get: function () {
            return this.identityMapping.emailVerificationEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IdentityMappingStore.prototype, "allowedDomains", {
        get: function () {
            return this.identityMapping.limitDomains.allowedDomains;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IdentityMappingStore.prototype, "isIdentifyByNameEnabled", {
        get: function () {
            return this.identityMapping.identifyByNameEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IdentityMappingStore.prototype, "isIdentifyByEmailEnabled", {
        get: function () {
            return this.identityMapping.identifyByEmailEnabled;
        },
        enumerable: false,
        configurable: true
    });
    IdentityMappingStore.prototype.setEmailVerification = function (enabled) {
        this.identityMapping.emailVerificationEnabled = enabled;
        if (!enabled) {
            this.identityMapping.limitDomains.enabled = false;
        }
        this.debouncedSave();
    };
    IdentityMappingStore.prototype.setLimitDomainsEnabled = function (enabled) {
        this.identityMapping.limitDomains.enabled = enabled;
        this.debouncedSave();
    };
    IdentityMappingStore.prototype.setAllowedDomains = function (domains) {
        if (!validateDomains(domains)) {
            return false;
        }
        this.identityMapping.limitDomains.allowedDomains = domains;
        this.debouncedSave();
        return true;
    };
    IdentityMappingStore.prototype.setIdentifyByNameEnabled = function (enabled) {
        this.identityMapping.identifyByNameEnabled = enabled;
        this.debouncedSave();
    };
    IdentityMappingStore.prototype.setIdentifyByEmailEnabled = function (enabled) {
        this.identityMapping.identifyByEmailEnabled = enabled;
        this.debouncedSave();
    };
    Object.defineProperty(IdentityMappingStore.prototype, "rawIdentityMapping", {
        get: function () {
            return (0, mobx_1.toJS)(this.identityMapping);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IdentityMappingStore.prototype, "identityMapping", {
        get: function () {
            this.fillInMissingDefaults();
            return this.link.identityMapping;
        },
        enumerable: false,
        configurable: true
    });
    IdentityMappingStore.prototype.fillInMissingDefaults = function () {
        if (this.link.identityMapping == undefined) {
            this.link.identityMapping = {
                emailVerificationEnabled: false,
                identifyByNameEnabled: false,
                identifyByEmailEnabled: false,
                limitDomains: DEFAULT_LIMIT_DOMAINS,
            };
            return;
        }
        if (this.link.identityMapping.limitDomains == undefined) {
            this.link.identityMapping.limitDomains = DEFAULT_LIMIT_DOMAINS;
            return;
        }
    };
    var _a;
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], IdentityMappingStore.prototype, "setEmailVerification", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], IdentityMappingStore.prototype, "setLimitDomainsEnabled", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Boolean)
    ], IdentityMappingStore.prototype, "setAllowedDomains", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], IdentityMappingStore.prototype, "setIdentifyByNameEnabled", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], IdentityMappingStore.prototype, "setIdentifyByEmailEnabled", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof IProjectLink_1.IdentityMapping !== "undefined" && IProjectLink_1.IdentityMapping) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], IdentityMappingStore.prototype, "rawIdentityMapping", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], IdentityMappingStore.prototype, "fillInMissingDefaults", null);
    return IdentityMappingStore;
}());
exports.IdentityMappingStore = IdentityMappingStore;
function validateDomains(allowedDomains) {
    var domains = parseAllowedDomains(allowedDomains);
    return !domains.some(function (domain) { return !validator_1.default.isFQDN(domain) && domain.length !== 0; });
}
function parseAllowedDomains(allowedDomains) {
    var domains = allowedDomains.split(",");
    return domains.map(function (domain) { return domain.trim(); });
}
